import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

interface NavbarProps {
  transparent?: boolean;
}

export default function Navbar({ transparent = false }: NavbarProps) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: '明星塌房', href: '/category/star-collapse' },
    { label: '网红翻车', href: '/category/influencer-fail' },
    { label: '综艺深扒', href: '/category/variety-deep' },
  ];

  const isTransparent = transparent && !isScrolled;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isTransparent
          ? 'bg-transparent'
          : 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <span className="w-9 h-9 rounded-full bg-primary-500 flex items-center justify-center">
              <i className="ri-fire-line text-background-50 text-lg"></i>
            </span>
            <span className={`font-heading font-bold text-lg ${isTransparent ? 'text-background-50' : 'text-foreground-900'}`}>
              51吃瓜爆料网
            </span>
          </Link>

          {/* Desktop Nav Links */}
          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.href;
              return (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                    isActive
                      ? 'bg-primary-500 text-background-50'
                      : isTransparent
                        ? 'text-background-50/90 hover:text-background-50 hover:bg-background-50/10'
                        : 'text-foreground-700 hover:text-foreground-900 hover:bg-background-200/70'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
          </div>

          {/* Desktop Right Actions */}
          <div className="hidden md:flex items-center gap-3">
            <button
              className={`w-9 h-9 rounded-full flex items-center justify-center transition-all duration-200 cursor-pointer ${
                isTransparent
                  ? 'text-background-50/90 hover:text-background-50 hover:bg-background-50/10'
                  : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-200/70'
              }`}
              aria-label="搜索"
            >
              <i className="ri-search-line text-lg"></i>
            </button>
            <Link
              to="/about"
              className={`w-9 h-9 rounded-full flex items-center justify-center transition-all duration-200 cursor-pointer ${
                isTransparent
                  ? 'text-background-50/90 hover:text-background-50 hover:bg-background-50/10'
                  : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-200/70'
              }`}
              aria-label="关于我们"
            >
              <i className="ri-information-line text-lg"></i>
            </Link>
            <Link
              to="/about"
              className="px-5 py-2 rounded-full bg-foreground-950 text-background-50 text-sm font-medium hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap flex items-center gap-1.5 cursor-pointer"
            >
              投稿爆料
              <i className="ri-arrow-right-line text-sm"></i>
            </Link>
          </div>

          {/* Mobile Menu Toggle */}
          <button
            className={`md:hidden w-9 h-9 rounded-full flex items-center justify-center cursor-pointer ${
              isTransparent ? 'text-background-50' : 'text-foreground-900'
            }`}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60 px-4 py-4">
          <div className="flex flex-col gap-2">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.href;
              return (
                <Link
                  key={link.href}
                  to={link.href}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className={`px-4 py-3 rounded-lg text-sm font-medium transition-all duration-200 cursor-pointer ${
                    isActive
                      ? 'bg-primary-500 text-background-50'
                      : 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
            <Link
              to="/about"
              onClick={() => setIsMobileMenuOpen(false)}
              className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:text-foreground-900 hover:bg-background-100 transition-all duration-200 cursor-pointer"
            >
              关于我们
            </Link>
            <Link
              to="/about"
              onClick={() => setIsMobileMenuOpen(false)}
              className="mt-1 px-5 py-3 rounded-full bg-foreground-950 text-background-50 text-sm font-medium text-center cursor-pointer"
            >
              投稿爆料
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}